import React, { Component } from 'react';

import { isEmpty, some } from "lodash"

import { TableLayout } from '../Menu/Stock/containers/Layout';

import {  toast } from 'react-toastify';

import FormNewUser from './Users/FormNewUser';
import FormNewRole from './Users/FormNewRole';
import FormChangeUserRole from './Users/FormChangeUserRole';
import FormUpdateRole from './Users/FormUpdateRole';
import { TableHead, TableRow, TableBody, TableCell, Button, Grid, IconButton } from '@material-ui/core';
import { AddCircleOutline, EditRounded, PersonRounded,Delete } from '@material-ui/icons';
import PageAdmin from './Layouts/PageAdmin';
import SearchBarAction from './Layouts/SearchBarAction';
import { blue } from '@material-ui/core/colors';
import CardButton from '../../commonModules/interface/CardButton';
import Dialog from '../../commonModules/interface/Dialog';

const initErrors = {
    role:"",
    email:"",
    userName:"",
    userPassword:"",
    pages:"",
    roleName:"",
    confirmMDP:"",
}
const PAGES = 
    [
        {value: "1000_Dashboard_Page", label: "Dashboard"},
        {value: '2000_Home_Page', label: 'Home' }, 
        {value: '3000_Entrer Paiement_Page', label: 'Entrer Paiement' },
        {value: '4000_Paiement_Page', label: 'Paiement' },
        // {value: "5000_Configuration_Page", label: "Configuration"}, admin Only
        // {value: "5500_Extract_Page", label: "Extract"},
        {value: "6000_Commercial_Page", label: "Commercial"},
        {value: "6500_Devis_Page", label: "Devis"},
        {value: "7000_Magasin_Page", label: "Magasin"},
        {value: "8000_Maintenance_Page", label: "Maintenance"},
        {value: "9000_Recouvrement_Page", label: "Recouvrement"},
        //{value: "10000_Production_Page", label: "Production"},
        //{value: "11000_Consommation_Page", label: "Consommation"},
        //{value: "12000_Financement_Page", label: "Financement"},
        //{value: "13000_Spendings_Page", label: "Dépenses"},
        {value: "14000_Mini-grid_Page", label: "Mini-grid"},
        
        // { value : "1_stats_Config", label: "Config - Home"},
        { value : "2_abo_Config", label: "Config - Abonnements"},
        { value : "3_agent_Config", label: "Config - Commerciaux"},
        { value : "4_schema_Config", label: "Config - Schémas"},
        { value : "5_sim_Config", label: "Config - Sim"},
        { value : "6_sms_Config", label: "Config - SMS"},
        { value : "7_alert_Config", label: "Config - Alerte"},
        { value : "8_box_Config", label: "Config - Systèmes et Box"},
        { value : "9_installer_Config", label: "Config -  Techniciens"},
        { value : "10_users_Config", label: "Config - Utilisateurs"},
        { value : "11_extract_Config", label: "Config - Extract"},
        { value : "12_upload_Config", label: "Config - Upload"},
        { value : "13_uploadstore_Config", label: "Config - Upload Magasin"},
        // { value : "14_credit_Config", label: "Config - Crédit"},
        // { value : "15_funding_Config", label: "Config - Financement"},
        // { value : "16_company_Config", label: "Config - Entreprise"},
        { value : "17_matching_Config", label: "Config - Match Produits"},
        // { value : "18_codesuperadmin_Config", label: "Config - Code Superadmin"},
    ]
class UsersList extends Component {
    state = {
        list:[],
        roleList:[],
        roleNames: {},

        roleU:"",// ROLE UPDATE
        roleUDisplay:{value:"", label:""},
        user: {},

        role:"",
        roleDisplay:{value:"", label:""},
        email:"",
        userName:"",
        userPassword:"",
        pages:[],
        roleName:"",
        confirmMDP:"",
        errors:initErrors,

        
        newUser:false,
        newRole:false,
        changeRole:false,
        updatePageList:false,
    }
    componentDidMount = async  () => {
        const { USERS } = this.props;
        if( !USERS ){
            await this.props.fetchUsers()
            await this.props.fetchRoles()
        }
        this.filterList()
        this.getRoleList()
    }
    filterList = (list) => {
        if( !list ){
            if(!isEmpty(this.props.USERS) ){
                list = Object.keys(this.props.USERS)
            } else {
                list = []
            }
        }
        this.setState({
            list
        })
    }
    getRoleList = async ()=>{
        const { ROLES } = this.props;
        if(ROLES){
            let roles = []
            let roleNames = {}
            Object.keys(ROLES).map(ID => {
                let role = ROLES[ID]
                let access = []
                role.accessPage.map( page => {
                    const info = page.split("_") // page => 1234_PageName_Page                    
                    access.push(info[1])
                })
                roles.push({
                    value:role.id, label:role.name, access:access
                })
                roleNames[role.name] = role.id
                
            })
            this.setState({
                roleList:roles,
                roleNames,
            })
        } else {
            this.setState({
                roleList:[{value:"", label:"", access: []}]
            })
        }
    }

    handleChange = (e) =>{
        let value = e.target.value
        let name = e.target.name
        this.setState({
            [name]: value
        })
    }
    handleSelectPage = (pages) => {
        this.setState({ pages });
        console.log(`Option selected:`, pages);
    }
    handleSelect = (option, field) => {
        let display = field+"Display"
        this.setState({ 
            [display]: option, 
            [field]: option.value
        }) 
    }
    validate = () =>{
        let noErrors = true
        let errors = {}
        const user = ['email', 'userName', 'role', 'userPassword']
        const role = ['roleName', 'pages']
        if(this.state.newUser === true){
            user.map( field  => {
                if (this.state[field] === "" || !this.state[field]){
                    errors[field] = 'Veuillez remplir ce champ'
                    noErrors = false
                } else {
                    errors[field]= ''
                }
            })
            if(this.state.userPassword !== this.state.confirmMDP){
                errors.confirmMDP = 'Le mot de passe et sa confirmation doivent etre identique'
                noErrors = false
            } else {
                errors.confirmMDP = ''
            }
        }

        if (this.state.newRole === true){
            role.map((field)=>{
                if (this.state[field] === "" || !this.state[field] || this.state[field].length === 0 ){
                    errors[field] = 'Veuillez remplir ce champ'
                    noErrors = false
                } else {
                    errors[field]= ''
                }
            })
        }
        this.setState({...this.state,errors})
        console.log("VALIDATE",{noErrors, errors});
        
        return noErrors
    }
    handleSubmit = async () =>{
        if(this.validate()){
            let data = {} 
            if (this.state.newUser === true){
                data.email = this.state.email
                data.userName = this.state.userName
                data.userPassword = this.state.userPassword
                data.roleID = this.state.role

                try {
                    let req = await fetch('/userRole/addUser',{
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        body: JSON.stringify(data),
                        credentials: 'same-origin',
               
                    })
                    const res = await req.json()
                    console.log("handleSubmit user",{res});
                    
                    if(!res.errorCode){

                        toast.done( "Nouvel utilisateur enregistré")
                        this.clearForms()

                        // update redux this.getUserList()
                    } else {
                        toast.error(res.content)
                    }
                } catch (error) {
                    toast.error( "Erreur", error)
                }
            }
            else if (this.state.newRole === true){
                data.roleName = this.state.roleName
                data.accessPages = []
                this.state.pages.map((page)=>{
                    data.accessPages.push(page.value)
                })

                try {
                    let req = await fetch('/userRole/addRole',{
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        body: JSON.stringify(data),
                        credentials: 'same-origin',
               
                    })
                    const res = await req.json()
                    console.log("handleSubmit role",{res});
                    if(!res.errorCode){
                        toast.success("Nouveau role enregistré")
                        this.clearForms()
                        // update redux this.getRoleList()
                    } else {
                       // this.props.notif( "danger", res.content, "Erreur")
                        toast.error(res.content)

                    }
                } catch (error) {
                    //this.props.notif( "danger", error, "Erreur")
                    toast.error(error)

                }
            }
            // submit requset
        } else {
            toast.error("Le formulaire contient des erreurs")
        }
    }
    
    handleUpdateRole = async () => {
        console.log('====================================');
        console.log("update role submit");
        console.log('====================================');
        if(this.state.role && !isEmpty(this.state.pages) ){
            console.log("OK", this.state.role, this.state.pages);
            let data = {} 
            if (this.state.updatePageList === true){
                data.accessPages = []
                this.state.pages.map( page => {
                    data.accessPages.push(page.value)
                })
                data.roleID = this.state.role

                try {
                    let req = await fetch('/userRole/updateRole',{
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        body: JSON.stringify(data),
                        credentials: 'same-origin',
               
                    })
                    const res = await req.json()
                    console.log("Update role ",{res});
                    
                    if(!res.errorCode){

                        toast.success("Role modifié")
                        this.clearForms()

                        // update redux this.getUserList()
                    } else {
                        console.log('====================================');
                        console.log("[ERROR] submit Update", res);
                        console.log('====================================');
                        // this.props.notif( "danger", "Un problème est survenu", "Erreur")
                    }
                } catch (error) {
                    console.log('====================================');
                    console.log("[ERROR] catch submit Update", error);
                    console.log('====================================');
                    // this.props.notif( "danger", error, "Erreur")
                }
            }
        } else {
            toast.error("Le formulaire contient des erreurs")
        }
    }
    handleChangeUserRole = async () =>{
        if(this.state.roleU && this.state.user.email){
            let data = {} 
            if (this.state.changeRole === true){
                data.email = this.state.user.email
                data.roleID = this.state.roleU

                try {
                    let req = await fetch('/userRole/updateUser',{
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        body: JSON.stringify(data),
                        credentials: 'same-origin',
               
                    })
                    const res = await req.json()
                    console.log("Update role ",{res});
                    
                    if(!res.errorCode){

                        toast.success("Role utilisateur modifié")
                        this.clearForms()

                        // update redux this.getUserList()
                    } else {
                        console.log('====================================');
                        console.log("[ERROR] submit Update", res);
                        console.log('====================================');
                        // this.props.notif( "danger", "Un problème est survenu", "Erreur")
                    }
                } catch (error) {
                    console.log('====================================');
                    console.log("[ERROR] catch submit Update", error);
                    console.log('====================================');
                    // this.props.notif( "danger", error, "Erreur")
                }
            }
        } else {
            toast.error("Le formulaire contient des erreurs")
        }
    }

    clearForms = () => {
        this.setState({
            roleU:"",// ROLE UPDATE
            roleUDisplay:{value:"", label:""},
            user: {},
            role:"",
            roleDisplay:{value:"", label:""},
            email:"",
            userName:"",
            userPassword:"",
            pages:[],
            roleName:"",
            confirmMDP:"",

            errors:initErrors,
            
            newUser:false,
            newRole:false,
            changeRole:false,
            updatePageList:false,
        })
    }

    createPageList = () => {
        const list = []
            
        PAGES.map( page => { 
            let selected = false
            if( some(this.state.pages, { value: page.value })  )  {  // already selected   
                selected = true 
            } 
            list.push (       
                {value:page.value, label:page.label, disabled:selected} 
            )
        })
        return list
        
    }
    render(){
        const {roleList, list} = this.state
        const { USERS } = this.props;
        let pageSelect = this.createPageList()
        let actions = [
            {
                openAction:() => this.setState({ newRole: true }),
                icon:<AddCircleOutline color="primary"/>,
                title: "Nouveau Role"
            },
            {
                openAction: () =>this.setState({ updatePageList: true }),
                icon: <EditRounded color="secondary" />,
                title: "Modifier un role"
            },
            {
                openAction: () =>this.setState({ newUser: true }),
                icon: <PersonRounded style={{ color: blue[200] }} />,
                title: "Nouvel Utilisateur"
            },
           
        ]
                // <Grid container className="text-center">
                //     <Grid item sm={4} xs={12}>
                //         <Button variant="contained" className="btn btn-info" onClick={()=>this.setState({newRole: true})} >Nouveau Role</Button>
                //     </Grid>
                //     <Grid item sm={4} xs={12}>
                //         <Button variant="contained" className="btn bgm-bluegray" onClick={()=>this.setState({updatePageList: true})} >Modifier un role</Button>
                //     </Grid>
                //     <Grid item sm={4} xs={12}>
                //         <Button variant="contained" className="btn btn-info" onClick={()=>this.setState({newUser: true})} >Nouvel Utilisateur</Button>
                //     </Grid>
                // </Grid> 
        
        return (
            <PageAdmin title="Utilisateurs et Roles">
                
                  
                <SearchBarAction list={ USERS } filterList={this.filterList} action={ () => this.setState({openFormTypes: true}) }/>
                {this.state.openFormTypes &&
                    <Dialog
                        title="Nouveau"
                        block={true}
                        close={() => this.setState({ 
                            openFormTypes: false,
                        }) }
                    >
                        {actions.map(action =>
                            <CardButton
                                action={action.openAction}
                                icon={action.icon}
                                title={action.title}
                            />
                        )}
                    </Dialog>
                }
                {this.state.newUser &&
                    <FormNewUser 
                        {...this.state}
                        {...this.props}
                        roleList={roleList}
                        handleChange={this.handleChange}
                        handleSubmit={this.handleSubmit}
                        handleSelect={this.handleSelect}
                        handleClose={this.clearForms}
                    />       
                
                }
                {this.state.newRole &&
                    <FormNewRole
                        {...this.state}
                        {...this.props}
                        pageSelect={pageSelect}
                        handleChange={this.handleChange}
                        handleSubmit={this.handleSubmit}
                        handleSelectPage={this.handleSelectPage}
                        handleClose={this.clearForms}
                    />       
                
                }
                {this.state.updatePageList &&
                    <FormUpdateRole
                        {...this.state}
                        {...this.props}
                        roleList={roleList}
                        pageSelect={pageSelect}
                        handleChange={this.handleChange}
                        handleSubmit={this.handleUpdateRole}
                        handleSelect={this.handleSelect}
                        handleSelectPage={this.handleSelectPage}
                        handleClose={this.clearForms}
                    />     
                
                }
                {this.state.changeRole &&
                    <FormChangeUserRole 
                        {...this.state}
                        {...this.props}
                        roleList={roleList}
                        handleChange={this.handleChange}
                        handleSubmit={this.handleChangeUserRole}
                        handleSelect={this.handleSelect}
                        handleClose={this.clearForms}
                    />     
                
                }
                    
                <h3>Liste des Utilisateurs</h3>
                <TableLayout height={"690px"}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Email</TableCell>
                            <TableCell>Role</TableCell>
                            <TableCell>Options</TableCell>
                            <TableCell>Disable</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {USERS && list.map( ID => {
                            let user = USERS[ID]
                            return(
                                <TableRow key={user.email}>
                                    
                                    <TableCell>{user.email}</TableCell>
                                    <TableCell>{user.role_name}</TableCell>
                                    <TableCell>
                                        <IconButton 
                                            className="btn btn-warning btn-icon" 
                                            onClick={
                                                () => this.setState({changeRole: true, user})
                                            }
                                            >
                                            {/* <i className="zmdi zmdi-edit"></i> */}
                                            <EditRounded />
                                        </IconButton>
                                    </TableCell>
                                    <TableCell>
                                        <IconButton 
                                            className="btn btn-warning btn-icon" 
                                            onClick={
                                                () => this.setState({changeRole: true, user})
                                            }
                                            >
                                            <Delete />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </TableLayout>
            </PageAdmin>
        )
    }
}

export default UsersList;




